import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import LinkFetcher from "./components/linkfetcher";
import ConfigurationPage from "./components/configurationpage";
import AppLayout from "./components/applayout";
import "./App.css";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<AppLayout />}>
          <Route path="/" element={<LinkFetcher />} />
          <Route
            path="/configuration"
            element={<ConfigurationPage />}
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;